// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__sXiVA","loaderBox":"loader_loaderBox__ZPJC9","loader":"loader_loader__W9ByW"};